export { PathologyApi } from './PathologyApi';
